import React from "react";

interface InputFieldProps {
  type?: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  startIconBg?: boolean;
  endIconBg?: boolean;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  ariaLabel?: string;
  ariaDescribedby?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  type = "text",
  value,
  onChange,
  placeholder,
  className,
  style,
  startIcon,
  endIcon,
  startIconBg = false,
  endIconBg = false,
  onKeyPress,
  ariaLabel,
  ariaDescribedby,
}) => (
  <div className={`input-group ${className || ""}`} style={style}>
    {startIcon && (
      <span
        className={`input-group-text d-flex align-items-center justify-content-center${
          startIconBg ? " bg-light" : ""
        }`}
        style={startIconBg ? { borderRadius: "6px 0 0 6px" } : undefined}
      >
        {startIcon}
      </span>
    )}
    <input
      type={type}
      className="form-control"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedby}
      onKeyPress={onKeyPress}
      style={{ border: "none" }}
    />
    {endIcon && (
      <span
        className={`input-group-text d-flex align-items-center justify-content-center${
          endIconBg ? " bg-light" : ""
        }`}
        style={endIconBg ? { borderRadius: "6px 6px 6px 6px" } : undefined}
      >
        {endIcon}
      </span>
    )}
  </div>
);

export default InputField;